












import {
  defineComponent,
  PropType
} from '@nuxtjs/composition-api';
import type { CustomizableOptionInterface } from '@wemade-vsf/magento-api';

interface ProductOptionInterface extends CustomizableOptionInterface {
  __typename: string
}

export default defineComponent({
  props: {
    options: {
      type: Array as PropType<Array<ProductOptionInterface>>,
      required: true
    },
    productPrice: {
      type: Number,
      default: 0
    }
  },
  components: {
    CustomizableAreaOption: () => import('components/catalog/Product/Details/ProductOptions/Renderer/CustomizableAreaOption.vue'),
    CustomizableCheckboxOption: () => import('components/catalog/Product/Details/ProductOptions/Renderer/CustomizableCheckboxOption.vue'),
    CustomizableDropDownOption: () => import('components/catalog/Product/Details/ProductOptions/Renderer/CustomizableDropDownOption.vue'),
    CustomizableFieldOption: () => import('components/catalog/Product/Details/ProductOptions/Renderer/CustomizableFieldOption.vue'),
    CustomizableMultipleOption: () => import('components/catalog/Product/Details/ProductOptions/Renderer/CustomizableMultipleOption.vue'),
    CustomizableRadioOption: () => import('components/catalog/Product/Details/ProductOptions/Renderer/CustomizableRadioOption.vue'),
  }
})
